var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("pilot-dialog", {
    attrs: {
      position: "right",
      scrollable: _vm.scrollable,
      minify: !_vm.isPilotPlayerExpanded,
      "no-header": !_vm.isPilotPlayerExpanded,
      title: _vm.$t("pilotTours"),
    },
    scopedSlots: _vm._u([
      {
        key: "header-left",
        fn: function () {
          return [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.bottom",
                    value: {
                      content: _vm.$t("selectPilot"),
                    },
                    expression:
                      "{\n        content: $t('selectPilot')\n      }",
                    modifiers: { bottom: true },
                  },
                ],
                staticClass: "pilot-tooltip-btn",
                on: { click: _vm.showPilotList },
              },
              [_c("i", { staticClass: "isif isif-pilot-hamburger" })]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "header-title-icon-right",
        fn: function () {
          return [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.bottom",
                    value: {
                      content: _vm.$t("scaleDown"),
                    },
                    expression: "{\n        content: $t('scaleDown')\n      }",
                    modifiers: { bottom: true },
                  },
                ],
                staticClass: "pilot-tooltip-btn",
                on: { click: _vm.toggleExpand },
              },
              [
                _c("i", {
                  staticClass: "isif",
                  class: {
                    "isif-pilot-chevron-up": _vm.isLargeScreen,
                    "isif-pilot-chevron-down": !_vm.isLargeScreen,
                  },
                }),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "header-right",
        fn: function () {
          return [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.bottom",
                    value: {
                      content: _vm.$t("pilotStop"),
                    },
                    expression: "{\n        content: $t('pilotStop')\n      }",
                    modifiers: { bottom: true },
                  },
                ],
                staticClass: "pilot-tooltip-btn",
                on: {
                  click: function ($event) {
                    return _vm.controlPilotPlayer("stop")
                  },
                },
              },
              [_c("i", { staticClass: "isif isif-close" })]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.isPilotPlayerExpanded
              ? _c("div", { staticClass: "expanded" }, [
                  _vm.pilotTour
                    ? _c("div", { staticClass: "pilot-tour" }, [
                        _c("div", { staticClass: "pilot-tour__thumbnail" }, [
                          _vm.pilotTour.pilotThumbnail ||
                          _vm.pilotTour.buildingThumbnail
                            ? _c("img", {
                                attrs: {
                                  src:
                                    _vm.pilotTour.pilotThumbnail ||
                                    _vm.pilotTour.buildingThumbnail,
                                },
                              })
                            : _c("i", { staticClass: "isif isif-man" }),
                        ]),
                        _vm._v(" "),
                        _vm.isOverTitleLength(
                          _vm.pilotTour.name +
                            "・" +
                            (_vm.currentPanorama.customCategory ||
                              _vm.$t(_vm.currentPanorama.category)) +
                            "・" +
                            _vm.pilotTour.ownerName
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "pilot-tour__title pilot-tour__title--marquee",
                              },
                              [
                                _c("div", { staticClass: "marquee-text" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.pilotTour.name +
                                          "・" +
                                          (_vm.currentPanorama.customCategory ||
                                            _vm.$t(
                                              _vm.currentPanorama.category
                                            )) +
                                          "・" +
                                          _vm.pilotTour.ownerName
                                      ) +
                                      "\n          "
                                  ),
                                ]),
                              ]
                            )
                          : _c("div", { staticClass: "pilot-tour__title" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.pilotTour.name +
                                      "・" +
                                      (_vm.currentPanorama.customCategory ||
                                        _vm.$t(_vm.currentPanorama.category)) +
                                      "・" +
                                      _vm.pilotTour.ownerName
                                  ) +
                                  "\n        "
                              ),
                            ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pilot-tour__progress" },
                          _vm._l(
                            _vm.tour.naviCollection,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: item.objectId,
                                  staticClass: "progress-bar",
                                  class: {
                                    "progress-bar--active":
                                      index === _vm.currentChapterIndex,
                                  },
                                  style: {
                                    width: _vm.chapterProgressWidth(
                                      item.duration
                                    ),
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "progress-bar__value",
                                    style: {
                                      transform: `scaleX(${_vm.chapterProgressValue(
                                        index,
                                        item.duration
                                      )})`,
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "pilot-tour__timeline" }, [
                          _c("div", { staticClass: "current-time" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.displayCumulativeDuration) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "duration" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.displayTotalDuration) +
                                "\n          "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pilot-tour__controls" }, [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.bottom",
                                  value: {
                                    content: _vm.$t("pilotReplay"),
                                  },
                                  expression:
                                    "{\n              content: $t('pilotReplay')\n            }",
                                  modifiers: { bottom: true },
                                },
                              ],
                              staticClass: "pilot-tooltip-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.controlPilotPlayer("replay")
                                },
                              },
                            },
                            [_c("i", { staticClass: "isif isif-pilot-replay" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "group" }, [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.bottom",
                                    value: {
                                      content: _vm.$t("pilotPrevious"),
                                    },
                                    expression:
                                      "{\n                content: $t('pilotPrevious')\n              }",
                                    modifiers: { bottom: true },
                                  },
                                ],
                                staticClass: "pilot-tooltip-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.controlPilotPlayer("backward")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "isif isif-pilot-backward",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.bottom",
                                    value: {
                                      content: _vm.isPilotPlaying
                                        ? _vm.$t("pilotPause")
                                        : _vm.$t("pilotPlay"),
                                    },
                                    expression:
                                      "{\n                content: isPilotPlaying ? $t('pilotPause') : $t('pilotPlay')\n              }",
                                    modifiers: { bottom: true },
                                  },
                                ],
                                staticClass: "pilot-tooltip-btn",
                                on: { click: _vm.togglePilotPlayerStatus },
                              },
                              [
                                _c("i", {
                                  staticClass: "isif",
                                  class: {
                                    "isif-pilot-pause": _vm.isPilotPlaying,
                                    "isif-pilot-play": !_vm.isPilotPlaying,
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.bottom",
                                    value: {
                                      content: _vm.$t("pilotNext"),
                                    },
                                    expression:
                                      "{\n                content: $t('pilotNext')\n              }",
                                    modifiers: { bottom: true },
                                  },
                                ],
                                staticClass: "pilot-tooltip-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.controlPilotPlayer("forward")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "isif isif-pilot-forward",
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.bottom",
                                  value: {
                                    content: _vm.isPilotSelfBrowsingMode
                                      ? _vm.$t("pilotTurnOffSelfBrowsingMode")
                                      : _vm.$t("pilotTurnOnSelfBrowsingMode"),
                                  },
                                  expression:
                                    "{\n              content: isPilotSelfBrowsingMode ? $t('pilotTurnOffSelfBrowsingMode') : $t('pilotTurnOnSelfBrowsingMode')\n            }",
                                  modifiers: { bottom: true },
                                },
                              ],
                              staticClass: "pilot-tooltip-btn",
                              on: { click: _vm.togglePilotSelfBrowsingMode },
                            },
                            [
                              _c("i", {
                                staticClass: "isif",
                                class: {
                                  "isif-close-flag":
                                    _vm.isPilotSelfBrowsingMode,
                                  "isif-flag": !_vm.isPilotSelfBrowsingMode,
                                },
                                style: {
                                  color: _vm.isPilotSelfBrowsingMode
                                    ? "#FFFFFF"
                                    : "#EC0974",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pilot-tour__chapters-title" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("pilotChaptersTitle")) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "horizontal-drag-scrolling",
                                rawName: "v-horizontal-drag-scrolling",
                                value: {
                                  startX: _vm.chaptersStartX,
                                  scrollLeft: _vm.chaptersScrollLeft,
                                  isMousedown: _vm.isChaptersMousedown,
                                },
                                expression:
                                  "{\n            startX: chaptersStartX,\n            scrollLeft: chaptersScrollLeft,\n            isMousedown: isChaptersMousedown\n          }",
                              },
                            ],
                            staticClass: "pilot-tour__chapters",
                          },
                          _vm._l(
                            _vm.tour.naviCollection,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: item.objectId,
                                  staticClass: "pilot-tour-chapter-card",
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectPilotChapter(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pilot-tour-chapter-card__thumbnail",
                                      class: {
                                        "pilot-tour-chapter-card__thumbnail--active":
                                          index === _vm.currentChapterIndex,
                                      },
                                    },
                                    [
                                      item.thumbnail
                                        ? _c("img", {
                                            attrs: { src: item.thumbnail },
                                          })
                                        : _c("i", {
                                            staticClass: "isif isif-man",
                                          }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pilot-tour-chapter-card__title",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pilotTour.description || _vm.showPilotTourImportantContent
                    ? _c("div", { staticClass: "pilot-tour__more-content" }, [
                        _c(
                          "button",
                          {
                            staticClass: "read-more-btn",
                            on: { click: _vm.onClickReadMore },
                          },
                          [
                            _c("i", {
                              staticClass: "isif isif-pilot-caret-down",
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("pilotReadMoreBtnLabel"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.pilotTour.description
                          ? _c(
                              "div",
                              {
                                ref: "introductionRef",
                                staticClass: "introduction",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "introduction__title" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("PilotDescription")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "introduction__text" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.pilotTour.description) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showPilotTourImportantContent
                          ? _c(
                              "div",
                              {
                                ref: "importantContentRef",
                                staticClass: "important-content",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "important-content__title" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t("PilotDetailedInformation")
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(3, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item,
                                      staticClass: "important-content__details",
                                    },
                                    [
                                      _vm.pilotTour[`pilotDetailedImage${item}`]
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.pilotTour[
                                                `pilotDetailedImage${item}`
                                              ],
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.pilotTour[
                                        `pilotDetailedDescription${item}`
                                      ]
                                        ? _c("div", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.pilotTour[
                                                    `pilotDetailedDescription${item}`
                                                  ]
                                                ) +
                                                "\n            "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "shrink" }, [
                  _vm.pilotTour
                    ? _c("div", { staticClass: "pilot-tour" }, [
                        _c(
                          "div",
                          {
                            staticClass: "pilot-tour__thumbnail",
                            on: { click: _vm.toggleExpand },
                          },
                          [
                            _vm.pilotTour.pilotThumbnail ||
                            _vm.pilotTour.buildingThumbnail
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      _vm.pilotTour.pilotThumbnail ||
                                      _vm.pilotTour.buildingThumbnail,
                                  },
                                })
                              : _c("i", { staticClass: "isif isif-man" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "pilot-tour__content",
                            on: { click: _vm.toggleExpand },
                          },
                          [
                            _vm.isOverTitleLength(
                              _vm.pilotTour.name +
                                "・" +
                                (_vm.currentPanorama.customCategory ||
                                  _vm.$t(_vm.currentPanorama.category)) +
                                "・" +
                                _vm.pilotTour.ownerName
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pilot-tour-title pilot-tour-title--marquee",
                                  },
                                  [
                                    _c("div", { staticClass: "marquee-text" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.pilotTour.name +
                                              "・" +
                                              (_vm.currentPanorama
                                                .customCategory ||
                                                _vm.$t(
                                                  _vm.currentPanorama.category
                                                )) +
                                              "・" +
                                              _vm.pilotTour.ownerName
                                          ) +
                                          "\n            "
                                      ),
                                    ]),
                                  ]
                                )
                              : _c("div", { staticClass: "pilot-tour-title" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.pilotTour.name +
                                          "・" +
                                          (_vm.currentPanorama.customCategory ||
                                            _vm.$t(
                                              _vm.currentPanorama.category
                                            )) +
                                          "・" +
                                          _vm.pilotTour.ownerName
                                      ) +
                                      "\n          "
                                  ),
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pilot-tour-progress" },
                              _vm._l(
                                _vm.tour.naviCollection,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.objectId,
                                      staticClass: "progress-bar",
                                      class: {
                                        "progress-bar--active":
                                          index === _vm.currentChapterIndex,
                                      },
                                      style: {
                                        width: _vm.chapterProgressWidth(
                                          item.duration
                                        ),
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "progress-bar__value",
                                        style: {
                                          transform: `scaleX(${_vm.chapterProgressValue(
                                            index,
                                            item.duration
                                          )})`,
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "pilot-tour__controls" }, [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.bottom",
                                  value: {
                                    content: _vm.isPilotPlaying
                                      ? _vm.$t("pilotPause")
                                      : _vm.$t("pilotPlay"),
                                  },
                                  expression:
                                    "{\n              content: isPilotPlaying ? $t('pilotPause') : $t('pilotPlay')\n            }",
                                  modifiers: { bottom: true },
                                },
                              ],
                              staticClass: "pilot-tooltip-btn",
                              on: { click: _vm.togglePilotPlayerStatus },
                            },
                            [
                              _c("i", {
                                staticClass: "isif",
                                class: {
                                  "isif-pilot-pause": _vm.isPilotPlaying,
                                  "isif-pilot-play": !_vm.isPilotPlaying,
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.bottom",
                                  value: {
                                    content: _vm.isPilotSelfBrowsingMode
                                      ? _vm.$t("pilotTurnOffSelfBrowsingMode")
                                      : _vm.$t("pilotTurnOnSelfBrowsingMode"),
                                  },
                                  expression:
                                    "{\n              content: isPilotSelfBrowsingMode ? $t('pilotTurnOffSelfBrowsingMode') : $t('pilotTurnOnSelfBrowsingMode')\n            }",
                                  modifiers: { bottom: true },
                                },
                              ],
                              staticClass: "pilot-tooltip-btn",
                              on: { click: _vm.togglePilotSelfBrowsingMode },
                            },
                            [
                              _c("i", {
                                staticClass: "isif",
                                class: {
                                  "isif-close-flag":
                                    _vm.isPilotSelfBrowsingMode,
                                  "isif-flag": !_vm.isPilotSelfBrowsingMode,
                                },
                                style: {
                                  color: _vm.isPilotSelfBrowsingMode
                                    ? "#FFFFFF"
                                    : "#EC0974",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.bottom",
                                  value: {
                                    content: _vm.$t("pilotStop"),
                                  },
                                  expression:
                                    "{\n              content: $t('pilotStop')\n            }",
                                  modifiers: { bottom: true },
                                },
                              ],
                              staticClass: "pilot-tooltip-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.controlPilotPlayer("stop")
                                },
                              },
                            },
                            [_c("i", { staticClass: "isif isif-close" })]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
            _vm._v(" "),
            _c("audio", {
              ref: "audioRef",
              attrs: { preload: "none" },
              on: { timeupdate: _vm.updateChapterCurrentTime },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }